function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BRI_ACTIVATION_STATUS } from 'invision-core/src/constants/pricing.plan.constants';
import { NON_BULK_SERVICE_STATUSES } from 'invision-core/src/constants/status.constants';
import { EMPTY_ARRAY } from 'invision-core/src/constants/common.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import { BILLER_RULE_INSTANCE_TYPE } from '../../customercare.constants';
import { getDiscountTooltipModel } from '../../components/shared/tooltipTemplates/discount.tooltip.helper';
import CustomerCareKeys from '../../locales/keys';
import moment from 'moment';
import pathOr from 'ramda/src/pathOr';
export var getActiveBillerTypeAmounts = function getActiveBillerTypeAmounts() {
  var billerTypeAmounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return billerTypeAmounts.filter(function (billerTypeAmount) {
    return billerTypeAmount.Status === BRI_ACTIVATION_STATUS.ACTIVE && (billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.RECURRING || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.ENTITLEMENT || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.ONETIME) || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.TRIGGER || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.EARLY_TERMINATION_FEE || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.CUSTOM;
  });
};
export var getActiveBillerTypePrices = function getActiveBillerTypePrices() {
  var billerTypeAmounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return billerTypeAmounts.filter(function (billerTypeAmount) {
    return billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.RECURRING || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.ENTITLEMENT || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.ONETIME || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.TRIGGER || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.EARLY_TERMINATION_FEE || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.CUSTOM;
  });
};
export var getFormattedBillerRulePrices = function getFormattedBillerRulePrices() {
  var billerTypeAmounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var billerRulePrices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var billerRulerPricesDictionary = billerRulePrices.reduce(function (acc, brp) {
    acc[brp.BillerRuleConfigurationId] = brp;
    return acc;
  }, {});
  return billerTypeAmounts.map(function (bta) {
    if (billerRulerPricesDictionary[bta.BillerRuleConfigurationId]) {
      var _billerRulerPricesDic = billerRulerPricesDictionary[bta.BillerRuleConfigurationId],
        TotalAmount = _billerRulerPricesDic.TotalAmount,
        BulkType = _billerRulerPricesDic.BulkType,
        Quantity = _billerRulerPricesDic.Quantity,
        ChargesFromRateSheet = _billerRulerPricesDic.ChargesFromRateSheet,
        StartDate = _billerRulerPricesDic.StartDate;
      return _objectSpread(_objectSpread({}, bta), {}, {
        TotalAmount: TotalAmount,
        BulkType: BulkType,
        Quantity: Quantity,
        ChargesFromRateSheet: ChargesFromRateSheet,
        StartDate: StartDate
      });
    }
    return bta;
  });
};
export var getDiscountAndBriDetails = function getDiscountAndBriDetails(option, currencyCode, discountsMetadataMap) {
  var discountAndBriInfo = [];
  var discountsInBri = [];
  var discountAndBriHasMap = {};
  var futureDiscountIndex = 0;
  var pastDiscountIndex = 0;
  var isBulk = option.BulkQuantity && option.BulkQuantity > 1;
  var activeBillerTypeAmounts = getActiveBillerTypeAmounts(option.BillerTypeAmounts);
  var activeBillerRulePrices = getActiveBillerTypePrices(option.BillerRulePrices);
  var amounts = isBulk ? getFormattedBillerRulePrices(activeBillerTypeAmounts, activeBillerRulePrices) : activeBillerTypeAmounts;
  var discounts = option.Discounts ? option.Discounts.filter(function (discount) {
    return discount.IsActive;
  }) : EMPTY_ARRAY;
  var futureDiscountsLength = 0;
  var pastDiscountsLength = 0;
  discounts.forEach(function (discount) {
    discount.StartDate && moment().diff(discount.StartDate, 'minutes') < 0 ? ++futureDiscountsLength : ++pastDiscountsLength;
  });
  discounts.forEach(function (discount) {
    var discountsBri = discount.StartDate && moment().diff(discount.StartDate, 'minutes') < 0 ? getDiscountTooltipModel(discount, currencyCode, discountsMetadataMap, discount.BillerRuleConfigurationId, ++futureDiscountIndex, undefined, futureDiscountsLength, pastDiscountsLength) : getDiscountTooltipModel(discount, currencyCode, discountsMetadataMap, discount.BillerRuleConfigurationId, undefined, ++pastDiscountIndex, futureDiscountsLength, pastDiscountsLength);
    discountsInBri.push(discountsBri);
    if (!discountAndBriHasMap[discount.BillerRuleConfigurationId]) {
      discountAndBriHasMap[discount.BillerRuleConfigurationId] = [];
      discountAndBriHasMap[discount.BillerRuleConfigurationId].push(discountsBri);
    } else {
      discountAndBriHasMap[discount.BillerRuleConfigurationId].push(discountsBri);
    }
  });
  discountAndBriInfo.push({
    briDetails: amounts,
    discountDetails: discountsInBri,
    pricingPlanId: option.PricingPlanId,
    discountAndBriHasMap: discountAndBriHasMap,
    hasBillerTypeAmounts: !!amounts.length
  });
  return discountAndBriInfo;
};
export var getServiceMoreActionMenuItems = function getServiceMoreActionMenuItems(serviceStatus, isEditable, hasSuspendResumeAccess, hasUpdateServiceLifecycleStatusAccess, isPIIDataAccessEnabled) {
  var moreMenuItems = {};
  var isServiceSuspended = serviceStatus === NON_BULK_SERVICE_STATUSES.SUSPENDED;
  var isPendingSuspension = serviceStatus === NON_BULK_SERVICE_STATUSES.PENDING_SUSPENSION;
  if (isPIIDataAccessEnabled) {
    moreMenuItems[CustomerCareKeys.MANAGE_ADD_ONS] = {
      id: CustomerCareKeys.MANAGE_ADD_ONS,
      title: i18n.translate(CustomerCareKeys.MANAGE_ADD_ONS),
      isLocked: isServiceSuspended || !isEditable,
      disabled: isServiceSuspended || !isEditable
    };
  }
  moreMenuItems[CustomerCareKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE] = {
    id: CustomerCareKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE,
    title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE)
  };
  if (hasSuspendResumeAccess) {
    if (serviceStatus === NON_BULK_SERVICE_STATUSES.ACTIVE) {
      moreMenuItems[CustomerCareKeys.SUSPEND_SERVICE] = {
        id: CustomerCareKeys.SUSPEND_SERVICE,
        title: i18n.translate(CustomerCareKeys.SUSPEND_SERVICE),
        isLocked: !isEditable,
        disabled: !isEditable
      };
    }
    if (isServiceSuspended || isPendingSuspension) {
      moreMenuItems[CustomerCareKeys.RESUME_SERVICE] = {
        id: CustomerCareKeys.RESUME_SERVICE,
        title: i18n.translate(CustomerCareKeys.RESUME_SERVICE)
      };
    }
  }
  if (hasUpdateServiceLifecycleStatusAccess) {
    if (serviceStatus === NON_BULK_SERVICE_STATUSES.ACTIVE) {
      moreMenuItems[CustomerCareKeys.UPDATE_SERVICE_LIFECYCLE_STATUS] = {
        id: CustomerCareKeys.UPDATE_SERVICE_LIFECYCLE_STATUS,
        title: i18n.translate(CustomerCareKeys.UPDATE_SERVICE_LIFECYCLE_STATUS),
        isLocked: !isEditable,
        disabled: !isEditable
      };
    }
  }
  return moreMenuItems;
};